/**
 * Pure display helpers for the WML Sync Contacts modal (kept separate so they are unit-testable
 * without rendering the modal).
 */

/** Server skip `reason` codes from syncContainer (WMLAddLegalContactsByManagerAPI.add). */
export const skipReasonLabel = (reason?: string): string => {
    switch (reason) {
        case "INACTIVE_EMPLOYEE": return "inactive";
        case "UNRESOLVED_EMPLOYEE": return "not found in PAPI";
        case "EXCLUDED_MANUALLY_REMOVED": return "previously removed from this container";
        default: return "skipped";
    }
};

/** Exclusion `reason` codes from discover's excludedEmployees. */
export const excludedReasonLabel = (reason?: string): string =>
    reason === "USER_REASSIGNED" ? "Reassigned to another person" : "Removed";

/** "Name (login)" when the remover's name is known, else the login, else "Unknown". */
export const removedByLabel = (removedBy?: { id?: string; name?: string }): string => {
    if (!removedBy?.id) return "Unknown";
    return removedBy.name ? `${removedBy.name} (${removedBy.id})` : removedBy.id;
};

/**
 * Expand the excluded section by default when nobody new can be added, so the admin sees why
 * the preview is empty; keep it collapsed when there are new people to review.
 */
export const shouldExpandExcluded = (newCount: number, excludedCount: number): boolean =>
    newCount === 0 && excludedCount > 0;

/** Info message shown when the preview finds nobody to add. */
export const noNewContactsMessage = (excludedCount: number): string =>
    excludedCount > 0
        ? "No new contacts to add. All eligible employees are already listed or were previously removed."
        : "No new contacts to add. All eligible employees are already listed.";
